var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconGroceries40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18197)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1678 11.1828L13.4669 7.771H17.9915L19.2906 11.1828C19.7137 12.294 19.9306 13.4731 19.9306 14.6621V20.5025H11.5278V14.6621C11.5278 13.4731 11.7447 12.294 12.1678 11.1828Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0621 5.22485H13.3965C12.7215 5.22485 12.1743 5.77206 12.1743 6.44708V6.54893C12.1743 7.22394 12.7215 7.77115 13.3965 7.77115H18.0621C18.7372 7.77115 19.2844 7.22394 19.2844 6.54893V6.44708C19.2844 5.77206 18.7372 5.22485 18.0621 5.22485Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5859 11.0505C19.1226 10.6534 19.9005 10.3954 20.697 10.5943C21.218 10.7243 21.747 11.2964 22.2215 11.2964C22.769 11.2964 23.3752 10.7177 23.9624 10.6032C24.7705 10.4455 25.5427 10.7817 26.0765 11.2218C27.2268 12.1702 27.7458 14.0351 27.5162 15.6048C27.1716 17.96 25.9196 19.7897 23.995 20.4783C22.8192 20.6093 22.9777 20.1646 22.2215 20.1646C21.9597 20.1646 21.8079 20.2186 21.6719 20.2832L21.5376 20.3496C21.3242 20.4544 21.0722 20.5493 20.4171 20.4661C18.5085 19.7677 17.2694 17.9459 16.9269 15.6048C16.683 13.9377 17.3099 11.9945 18.5859 11.0505Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6993 8.28052C22.8717 8.28052 22.1719 8.98351 22.1719 10.7681",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4479 18.3323L20.3625 19.2294L21.265 18.3261L22.9064 16.6831L25.4859 19.2294L28.1064 16.6831L30.5852 19.2294L30.625 35.7803H10V19.2294L12.5781 16.6831L15.1534 19.2294L17.7665 16.6831L19.4479 18.3323Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconGroceries40);
export default __webpack_public_path__ + "static/media/pictogramBeaconGroceries40.d602408ee3e5274765a207ded89beb83.svg";
export { ForwardRef as ReactComponent };